export const SAMPLE_CSV_DATA = `name,description,industry,website_url,logo_url
Nike,Athletic footwear and apparel,Sports & Recreation,https://nike.com,https://example.com/nike-logo.png
Apple,Technology and consumer electronics,Technology,https://apple.com,https://example.com/apple-logo.png
Coca-Cola,Beverage and soft drinks,Food & Beverage,https://coca-cola.com,https://example.com/coke-logo.png`;
